import React, { Component } from 'react'
import HeaderBox from 'client/shared/boxes/header-box'
import Footer from 'client/shared/blocks/footer/footer'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import { Location } from 'client/shared/types/react-router'
import './el-corazon-de-ls-bestia.styl'
import SVGInline from 'react-svg-inline'

import { authorList } from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/data'

import HeroLeftDtImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-dt-left.png'
import HeroLeftMdImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-md-left.png'
import HeroRightDtImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-dt-right.png'
import HeroRightMdImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-md-right.png'
import HeroMbImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-mb.png'
import HeroMbBottomImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-mb-bottom.png'
import TitleDtSVG from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/title-dt.svg'
import TitleMbSVG from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/title-mb.svg'
import AudioSVGIcon from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/audio-icon.svg'
import BookSVGIcon from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/book-icon.svg'
import HeroLogoImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/hero/hero-logo.png'
import AuthorsImg from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/autors-content-img-dt.png'

type Props = { location: Location } & DecoratorProps

class ElCorazonDeLaBestia extends Component<Props> {
  render(): JSX.Element {
    return (
      <div className="original__wrapper">
        <HeaderBox />
        <div className="hero-container">
          <div className="hero-grid">
            <div className="hero-left">
              <img className="dt" src={HeroLeftDtImg} alt="" />
              <img className="md" src={HeroLeftMdImg} alt="" />
            </div>
            <div className="hero-content">
              <div className="top-info">Bookmate Originals presenta</div>
              <div className="title">
                <SVGInline svg={TitleDtSVG} className="dt" />
                <SVGInline svg={TitleMbSVG} className="mb" />
              </div>

              <div className="mobile-img-top">
                <img src={HeroMbImg} alt="" />
              </div>
              <div className="content">
                Esta antología, editada por Leila Guerriero, reúne crónicas de
                seis destacados periodistas latinoamericanos, en donde exploran
                la compleja y cambiante relación entre humanos y animales. El
                libro construye un mosaico narrativo que recorre territorios
                urbanos y rurales, revelando los puntos de fricción entre lo
                humano y lo animal: el afecto, la crueldad, la domesticación, la
                violencia, la libertad y la convivencia.
              </div>
            </div>
            <div className="hero-right">
              <img className="dt" src={HeroRightDtImg} alt="" />
              <img className="md" src={HeroRightMdImg} alt="" />
            </div>
          </div>
          <div className="hero-footer">
            <div className="hero-logo">
              <img src={HeroLogoImg} alt="" />
            </div>
            <div className="mobile-img-bottom">
              <img src={HeroMbBottomImg} alt="" />
            </div>
            <div className="actions">
              <a href="https://es.bookmate.com/books/wFzPO8op">
                <SVGInline svg={BookSVGIcon} />
                Lee aquí
              </a>
              <div className="divider"></div>
              <a href="https://es.bookmate.com/audiobooks/nzmEpych">
                <SVGInline svg={AudioSVGIcon} />
                Escucha aquí
              </a>
            </div>
            <a
              className="link"
              /* href="https://es.bookmate.com/code?promo=CORAZONBESTIA" */
              href="https://es.bookmate.com/code"
            >
              Activa el código promocional aquí
            </a>
          </div>
        </div>
        <div className="landing-body">
          <div className="top-text">
            ¡Una lectura imprescindible, llena de humor y de datos curiosos para
            los amantes de la crónica, el periodismo narrativo y quienes se
            interesan por las cuestiones éticas y sociales en torno a los
            derechos de los animales!
          </div>
          <div className="author-list first">
            {authorList.slice(0, 2).map(item => (
              <div key={item.name} className="author-list-card">
                <img src={item.image} alt="" className="author-list-avatar" />
                <h3 className="author-list-name">{item.name}</h3>
                {item.date && (
                  <p className="author-list-location">{item.date}</p>
                )}
                <p className="author-list-bio">{item.description}</p>
              </div>
            ))}
          </div>
          <div className="author-list second">
            {authorList.slice(2).map(item => (
              <div key={item.name} className="author-list-card">
                <img src={item.image} alt="" className="author-list-avatar" />
                <h3 className="author-list-name">{item.name}</h3>
                {item.date && (
                  <p className="author-list-location">{item.date}</p>
                )}
                <p className="author-list-bio">{item.description}</p>
              </div>
            ))}
          </div>
          <div className="author-list-image">
            <img src={AuthorsImg} alt={''} />
          </div>
          <div className="links">
            <a href="https://es.bookmate.com/books">
              Lee este y miles de libros más aquí
            </a>
            <div className="link-divider"></div>
            <a
              /* href="https://es.bookmate.com/code?promo=CORAZONBESTIA" */
              href="https://es.bookmate.com/code"
            >
              Activa el código promocional aquí
            </a>
          </div>
        </div>
        <Footer />
      </div>
    )
  }
}

export default uiBox(ElCorazonDeLaBestia)
